import { get /*, post, put*/ } from "./axiosApi";
import { env } from "utils/env";

const masterPartnerUrl = env.REACT_APP_LEASING_API_URL;

export const loadUserInfo = () => {
  return get(`${masterPartnerUrl}/user/userInfo`);
};

export const loadUserMenus = () => {
  return get(`${masterPartnerUrl}/user/user-menus`);
};

export const loadUserAdditionalData = () => {
  return get(`${masterPartnerUrl}/user/user-additional-data`);
};

const userInfoLoad = { loadUserInfo };

export default userInfoLoad;
